import type { CustomTemplatePanelData } from './textAndLinkPanelTypes';
import { topBarPublishPopOverClick } from '@wix/bi-logger-editor/v2';
import * as util from '#packages/util';
import type { EditorAPI } from '#packages/editorAPI';
import * as helpIds from '#packages/helpIds';
import * as coreBi from '#packages/coreBi';
import * as stateManagement from '#packages/stateManagement';

const customTemplateSelectors = stateManagement.customTemplate.selectors;

export enum CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS {
  SITE_POST_PUBLISH = 'CUSTOM_TEMPLATE_SITE_POST_PUBLISH',
  SITE_PRE_PUBLISH = 'CUSTOM_TEMPLATE_SITE_PRE_PUBLISH',
}

export const CUSTOM_TEMPLATE_PUBLISH_PANEL_DATA_CONFIG: Record<
  CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS,
  CustomTemplatePanelData
> = {
  [CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS.SITE_POST_PUBLISH]: {
    title: 'TOPBAR_Templates_Secondpublish_Tooltip_Title',
    firstParagraph: 'TOPBAR_Templates_Secondpublish_Tooltip_Body',
    secondParagraph: 'TOPBAR_Templates_Secondpublish_Tooltip_Body2',
    links: [
      {
        titleKey: 'TOPBAR_Templates_Secondpublish_Tooltip_CTA',
        onClick: (editorAPI: EditorAPI) => {
          const isCustomTemplatePublished =
            customTemplateSelectors.getIsCustomTemplatePublished(
              editorAPI.store.getState(),
            );

          editorAPI.bi.event(
            coreBi.events.customTemplate.hover_on_publish_template,
            {
              action: 'learn_more',
              is_published_template: isCustomTemplatePublished,
            },
          );

          editorAPI.panelManager.openHelpCenter(
            helpIds.CUSTOM_TEMPLATE.WIX_STUDIO_SELLING_YOUR_CUSTOM_TEMPLATE,
          );

          util.biLogger.report(
            topBarPublishPopOverClick({
              target: 'learn_more',
            }),
          );
        },
        dataHook: 'custom-template-site-post-publish-learn-more',
      },
    ],
  },
  [CUSTOM_TEMPLATE_PUBLISH_PANEL_VIEWS.SITE_PRE_PUBLISH]: {
    title: 'TOPBAR_Templates_Prepublish_Tooltip_Title',
    firstParagraph: 'TOPBAR_Templates_Prepublish_Tooltip_Body',
    links: [
      {
        titleKey: 'TOPBAR_Templates_Prepublish_Tooltip_CTA',
        onClick: (editorAPI: EditorAPI) => {
          const isCustomTemplatePublished =
            customTemplateSelectors.getIsCustomTemplatePublished(
              editorAPI.store.getState(),
            );

          editorAPI.bi.event(
            coreBi.events.customTemplate.hover_on_publish_template,
            {
              action: 'learn_more',
              is_published_template: isCustomTemplatePublished,
            },
          );
          editorAPI.panelManager.openHelpCenter(
            helpIds.CUSTOM_TEMPLATE.WIX_STUDIO_SELLING_YOUR_CUSTOM_TEMPLATE,
          );

          util.biLogger.report(
            topBarPublishPopOverClick({
              target: 'learn_more',
            }),
          );
        },
        dataHook: 'custom-template-site-pre-publish-learn-more',
      },
    ],
  },
};
